// Merged service offerings for the home "Our Services" grid.
// The first three are pillars with dedicated detail pages (to);
// the rest are broader offerings shown as informational cards.
export const services = [
  {
    id: "transportation",
    icon: "local_shipping",
    title: "Transportation",
    description:
      "Seamless movement of goods across Kenya, Rwanda, Uganda, Tanzania, Congo, and Burundi.",
    to: "/transportation",
  },
  {
    id: "warehousing",
    icon: "warehouse",
    title: "Warehousing",
    description:
      "Secure, scalable, and efficient storage solutions for businesses of all sizes.",
    to: "/warehouse",
  },
  {
    id: "machinery",
    icon: "precision_manufacturing",
    title: "Machinery",
    description:
      "From heavy machinery to specialized tools, solutions built for your projects.",
    to: "/machinery",
  },
  {
    id: "storage",
    icon: "inventory_2",
    title: "Storage",
    description:
      "State-of-the-art facilities for short- and long-term storage, prioritising the safety of your goods.",
  },
  {
    id: "logistics",
    icon: "hub",
    title: "Logistics",
    description:
      "End-to-end logistics management with seamless coordination across your supply chain.",
  },
  {
    id: "cargo",
    icon: "package_2",
    title: "Cargo Handling",
    description:
      "From small parcels to large shipments — transport, documentation, and customs clearance handled.",
  },
  {
    id: "trucking",
    icon: "local_shipping",
    title: "Trucking",
    description:
      "A fleet of well-maintained vehicles and skilled drivers for fast, safe delivery.",
  },
  {
    id: "packaging",
    icon: "deployed_code",
    title: "Packaging",
    description:
      "High-quality materials and expert techniques to keep your items secure in transit.",
  },
];
